import React from 'react'
import PropTypes from 'prop-types'
import PageTitle from '../features/ui/util/page_title'
import DefaultLayout from '../layouts/default_layout'
import GroupCreate from '../features/group_create'
import { connect } from 'react-redux'
import { BREAKPOINT_EXTRA_SMALL } from '../constants'

class GroupCreatePage extends React.PureComponent {

  render() {
    const { children, isXS } = this.props
    
    const title = 'Create Group'

    return (
      <DefaultLayout
        noRightSidebar
        showBackBtn
        title={title}
        page='group-create'
        noPullToRefresh
        sidebarChildren={!isXS ? <GroupCreate showForm /> : undefined }
      >
        <PageTitle path={title} />
        {!isXS && children}
        
        {
          isXS &&
          <div className={[_s.d, _s.w100PC, _s.bgPrimary, _s.px15].join(' ')}>
            <GroupCreate showForm />
          </div>
        }
      </DefaultLayout>
    )
  }

}

const mapStateToProps = (state) => ({
  isXS: state.getIn(['settings', 'window_dimensions', 'width']) <= BREAKPOINT_EXTRA_SMALL,
})

GroupCreatePage.propTypes = {
  children: PropTypes.node.isRequired,
}

export default connect(mapStateToProps)(GroupCreatePage)